import { render, staticRenderFns } from "./MemberPurchaseHistoryDialog.vue?vue&type=template&id=615eb97b&scoped=true&"
import script from "./MemberPurchaseHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./MemberPurchaseHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./MemberPurchaseHistoryDialog.vue?vue&type=style&index=0&id=615eb97b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615eb97b",
  null
  
)

export default component.exports